// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1yRPt","colBig":"styles_colBig__2GdPR","colSmall":"styles_colSmall__1S2bz"};